import { api } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/quotes',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function accept(ctx, data) {
  try {
    const response = await api({
      url: `/quotes/${data.quoteId}/accept`,
      method: 'POST',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function refuse(ctx, data) {
  try {
    const response = await api({
      url: `/quotes/${data.quoteId}/refuse`,
      method: 'POST',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}